export const POST_LOGO_IMAGE = 'PUT_LOGO_IMAGE'
export const POST_LOGO_IMAGE_START = 'PUT_LOGO_IMAGE_START'
export const POST_LOGO_IMAGE_FAIL = 'PUT_LOGO_IMAGE_FAIL'
export const POST_LOGO_IMAGE_SUCCESS = 'PUT_LOGO_IMAGE_SUCCESS'